export const colorConfig = {
  Yellow: 'rgb(255, 243, 229)',
  Blue: 'rgb(59, 130, 246, 0.08)',
  Violet: 'rgb(153, 116, 249, 0.08)',
  Green: 'rgb(74, 222, 128, 0.08)',
  Pink: 'rgb(236, 72, 153, 0.08)',
  Orange: 'rgb(255, 141, 40, 0.08)',
}
